import { containsListAndRange } from '../../../../types/helpers/isProductOptionModelList.mjs';
import { DecoratorResult } from '../types/decorator-result.mjs';

function rangeDecorator(productOption) {
    const result = new DecoratorResult();
    if (containsListAndRange(productOption)) {
        const choices = productOption.choices.filter((choice) => "minimum" in choice);
        result.addMutation({
            type: "remove",
            reason: "choices have list models, filtering out list models for ranges",
            oldState: productOption.choices,
            newState: choices,
        });
        productOption.choices = choices;
    }
    return result;
}

export { rangeDecorator };
//# sourceMappingURL=range-decorator.mjs.map
